import React, { memo } from "react";
import { useParams } from "react-router-dom";
import { Dialog, DialogContent } from "investira.react.components";
import { useCarteirasContext } from "../../contexts/CarteirasContext";
import withResponseHandling from "../../hoc/withResponseHandling";

import CarteiraEditForm from "./CarteiraEditForm";

const DialogCarteiraEdit = memo((props) => {
  const { state } = useCarteirasContext();
  const params = useParams();

  const isOpen = state.isDialogOpen && state.dialogType === "carteira";

  return (
    <Dialog open={isOpen} fullWidth maxWidth="sm">
      <DialogContent sx={{ pt: 4 }}>
        {/* <Carteira id={params.id} mode="edit" /> */}
        <CarteiraEditForm id={params.id} />
      </DialogContent>
    </Dialog>
  );
});

export default withResponseHandling(DialogCarteiraEdit);
